import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const clocksExample: TemplateDefinition = {
  mode: "compose",
  slug: "clocks-example",
  version: 1,
  title: "Clocks",
  description: "Read analog time",
  thumbnailUuid: BASE_ASSETS.clocksExample.uuid,
  assets: [BASE_ASSETS.clocksExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.clocksExample.uuid,
              extension: BASE_ASSETS.clocksExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value:
            "What time is it in Portland, Oregon? Pay close attention to the precise placement of hour and minute hands.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    temperature: 0,
    annotationFormat: null,
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
